import Vue from "vue";
import Vuex from "vuex";
import { app } from "./app";
import { request } from "./request";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app,
        request,
    },
});

export { store };
